import axios, { baseUrl } from "../axios/axios";
import {
  VolunteerProfileRequest,
  VolunteerProfileResponse,
  VolunteerWorkingHoursEntry,
} from "../types/volunteerProfile.types";
import { UserResponse } from "../types/shared";

/**
 * Get the volunteer profile for a user.
 * @returns the profile, or null when none exists yet (404 -> create flow)
 */
export const getVolunteerProfile = async (
  userId: number
): Promise<VolunteerProfileResponse | null> => {
  try {
    const response = await axios.get<VolunteerProfileResponse>(
      `${baseUrl}/volunteer_profile/user_id/${userId}`
    );
    return response.data;
  } catch (err: any) {
    if (err.response?.status === 404) {
      return null;
    }
    throw err;
  }
};

export const createVolunteerProfile = async (
  request: VolunteerProfileRequest
): Promise<void> => {
  await axios.post(`${baseUrl}/volunteer_profile`, request);
};

export const updateVolunteerProfile = async (
  request: VolunteerProfileRequest
): Promise<void> => {
  await axios.put(`${baseUrl}/volunteer_profile`, request);
};

/**
 * Replaces the whole schedule; the body is a bare JSON array. Times must be
 * strictly "HH:mm".
 */
export const updateVolunteerWorkingHours = async (
  userId: number,
  entries: VolunteerWorkingHoursEntry[]
): Promise<void> => {
  await axios.put(
    `${baseUrl}/volunteer_profile/user_id/${userId}/working_hours`,
    entries
  );
};

/**
 * available=false means paused (on a break); available=true clears the pause.
 */
export const setVolunteerAvailability = async (
  userId: number,
  available: boolean
): Promise<void> => {
  await axios.put(
    `${baseUrl}/volunteer_profile/user_id/${userId}/availability`,
    null,
    { params: { available } }
  );
};

export const getMyCustomers = async (
  volunteerUserId: number
): Promise<UserResponse[]> => {
  const response = await axios.get<UserResponse[]>(
    `${baseUrl}/favourite_volunteer/my_customers/${volunteerUserId}`
  );
  return response.data;
};
